$(window).on( 'load', function() {

  mobileFallBack();

} );

$(document).ready( function() {

  $('#fullpage').fullpage( {

    anchors: ['firstPage', 'secondPage', '3rdPage', '4thPage', '5thPage', '6thPage', '7thPage', '8thPage','9thPage','10thPage','11thPage','12thPage','13thPage','14thPage','15thPage','16thPage'],
    navigationPosition: 'left',
    autoScrolling: false,
    scrollingSpeed: 550,
    // navigationTooltips: ['Levi\'s','Carrera sport','Carrera eyewear','Carrera sport','Carrera sport','Levi\'s skateboarding','Panini spa','Panini spa','Safilo spa','Carrera sport','Carrera sport','Hakufax dugutak bros spa','Empire', 'PrimaLight', 'JVC kenwood'],
    navigation: true,
    verticalCentered: false,
    autoScrolling: true,
    fitToSection: true,

    afterLoad: function( anchorLink, index ) {

      // load previous and next slide for fast navigation
      preloadPrevNextSlide(index);

      var curSlide = $("#section" + index);

      // display copy
      curSlide.find(".section-copy").css( {
        'transform': 'translate(0%, 0%)',
        opacity: 1
      } );

      curSlide.find('video').each( function() {
        $(this).get(0).play();
      } );

    },

    onLeave: function(index, nextIndex, direction){
      var curSlide = $("#section" + index);

      curSlide.find('video').each( function() {
        $(this).get(0).pause();
        $(this).get(0).currentTime = 0;
      } );

    }

  });

});

$(window).resize( function(){
  mobileFallBack();
});


function mobileFallBack(){

  if( (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) || $(window).width() <= 960 ) {

    $('.text-animation').hide();
    $('video').css('display', 'none');

  } else {

    $('.text-animation').show();
    $('video').css('display', 'block');

  }

}


function preloadPrevNextSlide( index ) {

  for( var i = index-1; i<= index+1; i++ ) {

    if ( $("#section" + i ).attr('data-src') ) {
      $("#section" + i ).css('background', 'url("'+$("#section" + i ).attr('data-src') + '")' );
      $("#section" + i ).removeAttr('data-src');
    }

  }

}



//////////////////
// WEBPACK FOOTER
// ./js/modules/fullpagejs-manager.js
// module id = 32
// module chunks = 0